async function process(){
    pageLoading(true);

    var config = await loadConfigFile();

    await loadAppDependencies();

    var route = getRoute();
    if (route === null) {
        let URL = Plastic.URL.info;
        route = Plastic.App["route"] = {
            controller: `/${URL["path"]}/controller`,
            params: URL["params"],
            path: `/${URL["path"]}`
        };
    }

    await ifSetCall(config.load);

    var [filePath, exportVar] = route["controller"].split("#");

    var controller = await loadControllerFile();

    setHTMLHead();

    try {castParams();}
    catch(e){return redirect(422);}

    await loadControllerDependencies();

    try {await authenticate();}
    catch(e){return redirect(401);}

    await callMiddleware();

    var loadOutput = await callControllerLoad();
    // result: (all optional)
    //  - redirect
    //  - view path
    //  - bag: things to pass to after view

    if (isPresent(loadOutput["redirect"]))
        return redirect(loadOutput["redirect"]);

    await loadStyles();

    try {var view = await loadViewFile();}
    catch(e){return redirect(404);}

    populatePage(view);

    await loadAppNav();

    await ifSetCall(config.loaded);

    await ifSetCall(controller["loaded"], [{
        bag: loadOutput["bag"], config, controller,
        params: route["params"], route, user: Plastic.App["user"]
    }]);

    pageLoading(false);

    async function authenticate(){
        if (!controller["authenticate"]) return;

        var optional = controller["authenticate"] !== true;
        var authentication = config["authentication"];

        var user = await authentication.user();
        if (isPresent(user)) return Plastic.App["user"] = user;
        if (!optional) throw 401;
    }
    async function callControllerLoad(){
        var output = await ifSetCall(controller["load"], [{
            params: route["params"],
            user: Plastic.App["user"],
            route, config, controller
        }]);
        return isPresentOr(output, {});
    }
    async function callMiddleware(){
        var hasMiddleware = isPresent(config["middleware"]);
        var middlewareEnabled = controller["middleware"] !== false;
        if (!hasMiddleware || !middlewareEnabled) return;

        var middlewares = Object.keys(config["middleware"]);
        if (isPresent(controller["middleware_only"])){
            middlewares = whitelist(middlewares, controller["middleware_only"]);
        }
        if (isPresent(controller["middleware_except"])){
            middlewares = blacklist(middlewares, controller["middleware_except"]);
        }
        await asyncLoop(middlewares, async function(middleware){
            await config["middleware"][middleware]({
                params: route["params"],
                user: Plastic.App["user"],
                route, config, controller
            });
        });
    }
    async function loadAppDependencies(){
        if (isEmpty(config["dependencies"])) return;
        await Plastic.Load(config["dependencies"]);
    }
    async function loadAppNav(){
        var nav = isPresentOr(config["nav"], config["appNav"]);

        if (isPromise(config["nav"]))           nav = await config["nav"];
        else if (isPromise(config["appNav"]))   nav = await config["appNav"];

        if (isUndefined(nav)) return;

        var placeholder = $("#plastic-app-nav-placeholder");
        if (placeholder.length < 1){
            placeholder = createElement("div");
            placeholder.attr("id", "plastic-app-nav-placeholder");
            prependElements("body", [placeholder]);
        }

        await Plastic.Load(["AppNav"]);
        await Plastic.AppNav.load(nav, [
            "navConfig", "nav", "appNav", "navigation", "appNavConfig", "config"
        ]);
    }
    async function loadConfigFile(){
        var configFilenames = ["/config.min.js", "/config.js", "/app.config"];
        var config = await loadFile(configFilenames, "js", ["app", "config"]);
        if (isPresent(config)){
            if (isPromise(config["authentication"])) config["authentication"] = await config["authentication"];
            if (isPromise(config["middleware"])) config["middleware"] = await config["middleware"];
            if (isPromise(config["routes"])) config["routes"] = await config["routes"];
            config = updateOldConfig(config);
            Plastic.App["config"] = mergeObjects(Plastic.App["config"], config, true);
        }
        return Plastic.App["config"];

        function updateOldConfig(config){
            // Future Remove this function after July 2023
            if (isPresent(config["globalViewStyles"])){
                config["styles"] = config["globalViewStyles"];
            }
            return config;
        }
    }
    async function loadControllerDependencies(){
        if (isEmpty(controller["dependencies"])) return;
        await Plastic.Load(controller["dependencies"]);
    }
    async function loadControllerFile(){
        exportVar = isPresentOr(exportVar, "controller");
        var controller = await loadFile([`${filePath}.min.js`, `${filePath}.js`], "js", exportVar);
        controller = isPresentOr(controller, {});
        if (isPresent(controller["viewStyles"])){
            controller["styles"] = controller["viewStyles"];
        }
        if (isPresent(controller["config"])){
            loopProps(controller["config"], (name, value) => {
                assignProp(Plastic.App, `config.${name}`, value);
            });
        }
        return controller;
    }
    async function loadFile(names, type, exportVars){
        var contents = null;
        await asyncLoop(names, async (name) => {
            try {
                contents = await getFileContents(name, type, exportVars);
                return true;
            }
            catch(e){
                // console.error(e);
            }
        });
        return contents;

        async function currentPageHash(){
            if (isPresent(Plastic.App.currentPageHash)) return Plastic.App.currentPageHash;

            var url = Plastic.URL.info["url"];
            var page = await Plastic.Load.return(url, "html");
            Plastic.App.currentPageHash = await hashPageContents(page);
            return Plastic.App.currentPageHash;
        }
        async function hashPageContents(contents){
            contents = htmlString(contents);
            contents = isPresentOr(contents, "");

            try {return await hashStr(contents);}
            catch (e){return createFallbackHash();}

            function createFallbackHash(){
                return Array.from(contents).reduce((hash, char) => 0 | (31 * hash + char.charCodeAt(0)), 0);
            }
        }
        async function getFileContents(filePath, type, exportVar){
            filePath = withFileExt(filePath, type);
            if (type !== "html") return await Plastic.Load.return(filePath, type, exportVar);

            var html = await Plastic.Load.return(filePath, "html");
            var hash = await hashPageContents(html);

            if (await currentPageHash() === hash) throw null;

            return html;

            function withFileExt(path, type){
                var extension = arrayLast(path.split(".")).toLowerCase();
                return extension === type ? path : `${path}.${type}`;
            }
        }
    }
    async function loadStyles(){
        var styles = concatAll(config["styles"], controller["styles"]);
        await Plastic.Load(styles, {waitForCSS: true});
    }
    async function loadViewFile(){
        var view = isPresentOr(loadOutput["view"], controller["view"], "");

        var filesToTry = [];

        var index = filePath.lastIndexOf("/");
        var controllerDir = filePath.slice(0, index);

        try {
            if (isPresent(view)){
                var isAbsolute = view.charAt(0) === "/";
                if (isAbsolute) filesToTry.push(view);
                else filesToTry.push(`${controllerDir}/${view}`);
            }
        }
        catch(e){console.log(e);}

        filesToTry.push(`${controllerDir}/view`);
        filesToTry.push(`${controllerDir}/index`);

        var html = await loadFile(filesToTry, "html");
        if (html === null) throw 404;

        return html;
    }

    function castParams(){
        if (isEmpty(controller["params"])) return;

        loopProps(controller["params"], (param, options) => {
            var required = options !== false;
            required = objProp(options, "required", required);

            var value = objProp(route, `params.${param}`);
            var type = objProp(options, "type", options);
            if (isPresent(value) && isString(type)){
                value = castStrTo(value, type);
            }
            if (required && isEmpty(value)) throw 422;

            route["params"][param] = value;
        });
    }
    function getRoute(){
        var URL = Plastic.URL.process({
            persist: true,
            routes: Object.keys(config["routes"])
        });
        if (URL["route"] === null) return null;

        Plastic.App["route"] = {
            controller: config["routes"][URL["route"]],
            params: URL["params"],
            path: URL["route"]
        };

        return Plastic.App["route"];
    }
    function pageLoading(show){
        var loadingContainer = $("#app-page-loading");
        if (loadingContainer.length < 1){
            var icon = createIcon("fas fa-spinner fa-spin");
            loadingContainer = createElement("div", "", [
                icon, " &nbsp;&nbsp; Loading, Please Wait..."
            ]);
            loadingContainer.attr("id", "app-page-loading");
            prependElements("body", [loadingContainer]);
        }

        var body = $("body");
        var html = $("html");
        if (show){
            body.attr("app-load-overflow", getStyle(body, "overflow"));
            html.attr("app-load-overflow", getStyle(html, "overflow"));
            $("html, body").css("overflow", "hidden");
        }
        else {
            body.css("overflow", body.attr("app-load-overflow"));
            html.css("overflow", html.attr("app-load-overflow"));
        }

        showIf(!show, "#app-content-container");
        showIf(show, loadingContainer);
    }
    function populatePage(content){
        var container = $("#app-content-container");
        if (container.length < 1){
            container = createElement("div");
            container.attr("id", "app-content-container");
            prependElements("body", [container]);
        }

        replaceElements("#app-content-container", [content]);
    }
    function setHTMLHead(){
        setDocMeta(config["meta"]);
        setDocViewport(config["meta_viewport"]);
        setDocTitle(config["title"]);
        setDocFavIcon(config["favIcon"]);
        setupGoogleAnalytics(config["googleAnalytics"]);

        function setupGoogleAnalytics(tagIds){
            if (isEmpty(tagIds)) return;

            tagIds = toArray(tagIds);

            // Don't wait.
            Plastic.Load([`https://www.googletagmanager.com/gtag/js?id=${tagIds[0]}`], {type: "js"}).catch(console.error);
            window.dataLayer = window.dataLayer || [];
            gtag("js", new Date());

            forLoop(tagIds, tagId => {
                gtag("config", tagId);
            });
        }
    }
}
async function redirect(whichWhere){
    if (isString(whichWhere)) {
        window.location = whichWhere;
        await delayWait(10000);
    }

    var redirect = Plastic.App.config["redirects"][whichWhere];
    if (isPresent(redirect)) {
        window.location = redirect;
        await delayWait(10000);
    }

    switch (whichWhere){
        case 401: case "401": return document.write("UNAUTHORIZED");
        case 404: case "404": return document.write("NOT FOUND");
        case 422: case "422": return document.write("UNPROCESSABLE ENTITY");
        default: return document.write("");
    }
}

function addGATag(tagId, config){
    if (isPresent(config)) gtag("config", tagId, config);
    else gtag("config", tagId);
}
function gtag(){window.dataLayer.push(arguments);}
function params(key, exact){
    var params = Plastic.App.route["params"];

    if (isPresent(key)){
        var output = null;
        if (!exact) key = key.toLowerCase();
        loopProps(params, function(name, value){
            if (!exact) name = name.toLowerCase();
            if (key === name) {
                output = value;
                return true;
            }
        });
        return output;
    }
    return params;
}
function setDocFavIcon(iconHref){
    if (isEmpty(iconHref)) return;

    var tag = $("link[rel='icon']");
    if (tag.length < 1){
        tag = createElement("link");
        tag.attr("rel", "icon");
        tag.attr("type", "image/x-icon");
        appendElements("head", [tag]);
    }
    tag.attr("href", iconHref);
}
function setDocMeta(meta){
    if (isEmpty(meta)) return;

    var tags = [];
    loopProps(meta, (name, content) => {
        var tag = getTag(name);
        tag.attr("content", content);
    });
    appendElements("head", tags);

    function getTag(name){
        var tag = $(`meta[name="${name}"]`);
        if (tag.length > 0) return $(tag[0]);

        tag = createElement("meta");
        tag.attr("name", name);
        tags.push(tag);
        return tag;
    }
}
function setDocTitle(title){
    if (isEmpty(title)) return;

    var tag = $("title");
    if (tag.length < 1) {
        tag = createElement("title");
        appendElements("head", [tag]);
    }
    tag.html(title);
}
function setDocViewport(viewport){
    if (viewport === false) return;

    var defaults = "width=device-width, initial-scale=1";
    var settings = isString(viewport) ? viewport : defaults;
    setDocMeta({viewport: settings});
}

/**
 *  @alias Plastic.App
 */
var App = {
    dependencies: ["Helpers", "URL", "App/styles.css"],
    config: {
        html: {
            lang: "en-US",
            meta: {}
        },
        redirects: {},
        routes: [],
    },
    currentPageHash: null,
    route: {},
    user: null,
    gtag: gtag,
    gtagId: addGATag,
    htmlMeta: setDocMeta,
    htmlTitle: setDocTitle,
    htmlIcon: setDocFavIcon,
    init: process,
    params: params,
    redirect: redirect
};